<template>
  <div class="dongle-list px">
    <div class="list">
      <div class="item unlinked" v-if="dongleList.length === 0">
        <i class="iconfont icondongle" /> AM Sniper2.4
        {{ $t("loader.unlinked") }}
      </div>
      <template v-else>
        <div
          v-for="(dongle, index) in dongleList"
          class="item"
          :class="{
            active: currentDongle && dongle.port === currentDongle.port,
          }"
          :key="dongle.port"
          @click="onDongleClick(dongle)"
        >
          <i class="iconfont icondongle" />
          {{ dongleList.length === 1 ? "AM Sniper2.4" : index + 1 }}
          {{ $t("loader.linked") }}
          <div
            class="update"
            v-if="!dongle.isLatestVersion"
            @click="onDongleUpdate(dongle)"
          >
            {{ $t("loader.update") }}
          </div>
        </div>
      </template>
    </div>
    <swiper
      class="device-list"
      :options="options"
      @slideChange="onSwiper"
      v-if="currentDongle && currentDongle.deviceList"
    >
      <swiper-slide
        v-for="(device, index) in currentDongle.deviceList"
        :key="'device_' + index"
      >
        <div
          class="item"
          :class="{
            active: currentDevice && device.port === currentDevice.port,
          }"
          @click="onDeviceClick(device)"
        >
          <img class="device" :src="images['device_' + device.code]" />
          <div class="name">
            {{ deviceName[device.code] }}
          </div>
          <div class="next">
            <i class="iconfont iconlightning" />
          </div>
        </div>
      </swiper-slide>
    </swiper>
    <div class="text" v-else>
      {{ $t("loader.undetected") }}
    </div>
    <div
      class="button"
      v-if="currentDongle && currentDongle.deviceList"
      @click="onPair"
      :disabled="!(currentDongle && currentDevice)"
    >
      {{ $t("loader.pair") }}
    </div>
    <div class="message">
      {{ message }}
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import "swiper/swiper-bundle.min.css";

export default {
  data() {
    return {
      message: "",
      dongleList: [],
      currentDongle: null,
      currentDevice: null,
    };
  },
  computed: {
    ...mapState("assets", {
      images: "images",
    }),
    ...mapState("app", {
      isCN: "isCN",
    }),
    ...mapState("loader", {
      deviceName: "deviceName",
    }),
    options() {
      return {
        speed: 400,
        mousewheel: true,
        effect: "coverflow",
        coverflowEffect: {
          depth: 300, // 深度
          rotate: -17, // 旋转角度
          scale: 1,
          stretch: -50, // 拉伸度
          slideShadows: false, // 是否显示滑动阴影
        },
      };
    },
  },
  methods: {
    onSwiper(swiper) {
      const device = this.currentDongle.deviceList[swiper.activeIndex];
      device;
    },
    onDongleClick(dongle) {
      this.currentDongle = { ...dongle };
      this.currentDevice = null;
    },
    onDongleUpdate(dongle) {
      this.$store.dispatch("loader/updateDongle", {
        dongle: {
          port: dongle.port,
        },
      });
    },
    onDeviceClick(device) {
      this.currentDevice = { ...device };
    },
    onPair() {
      if (!(this.currentDongle && this.currentDevice)) return;
      this.$store.dispatch("loader/pairDongle", {
        dongle: {
          port: this.currentDongle.port,
        },
        device: this.currentDevice,
      });
    },
  },
  mounted() {
    this.$store.dispatch("loader/getDongleList");
    window.setDongleList = (json) => {
      if (json) {
        const data = JSON.parse(json);
        console.log("Bridge", "setDongleList", data);
        this.dongleList = data.dongleList;
        console.log("this.dongleList.length", this.dongleList.length);
        console.log("this.currentDongle", this.currentDongle);
        if (this.dongleList.length > 0 && !this.currentDongle) {
          this.currentDongle = this.dongleList[0];
          console.log("this.currentDongle", this.currentDongle);
        }
      }
    };
    window.updateDongleProgress = (json) => {
      if (json) {
        const data = JSON.parse(json);
        this.message = this.isCN ? data.message.zh_CN : data.message.en_US;
        if (this.percent >= 100) {
          this.$store.dispatch("loader/getDongleList");
        } else if (this.percent === -1) {
          this.$info({
            title: this.$t("loader.failToUpdate"),
            width: "8.4rem",
            okText: this.$t("yes"),
            cancelText: this.$t("cancel"),
            centered: true,
          });
          this.message = "";
        }
      }
    };
    window.pairDongleProgress = (json) => {
      if (json) {
        const data = JSON.parse(json);
        this.message = this.isCN ? data.message.zh_CN : data.message.en_US;
        if (this.percent >= 100) {
          this.$store.dispatch("loader/getDongleList");
        } else if (this.percent === -1) {
          this.$info({
            title: this.$t("loader.failToPair"),
            width: "8.4rem",
            okText: this.$t("yes"),
            cancelText: this.$t("cancel"),
            centered: true,
          });
          this.message = "";
        }
      }
    };

    if (window.location.href.includes("localhost")) {
      setTimeout(() => {
        this.dongleList = [
          {
            port: "COM1",
            isLatestVersion: true,
            deviceList: [
              {
                code: "cb02",
                port: "COM3",
              },
              {
                code: "alice",
                port: "COM4",
              },
            ],
          },
          {
            port: "COM2",
            isLatestVersion: false,
            deviceList: [
              {
                code: "alice",
                port: "COM4",
              },
              {
                code: "65les",
                port: "COM5",
              },
            ],
          },
        ];
        if (this.dongleList.length > 0 && !this.currentDongle) {
          this.currentDongle = this.dongleList[0];
        }
      }, 2000);
    }
  },
};
</script>
<style lang="scss" scoped>
.dongle-list {
  @include flex-center;
  min-height: inherit;
  color: #ffffff;
  overflow: hidden;
  flex-direction: column;

  .list {
    @include flex-center;
    position: fixed;
    left: 130px;
    top: 40px;
    text-align: center;
    cursor: pointer;

    .item {
      @include flex-center;
      font-size: 30px;
      margin-right: 15px;
      color: #ffffff;

      &.unlinked {
        color: $active-color;
      }

      &.active,
      &:hover {
        color: $primary-color;
      }

      .iconfont {
        font-size: 30px;
        margin-right: 5px;
      }

      .update {
        @include linear-button;
        font-size: 20px;
        padding: 6px 20px;
        margin-left: 5px;
      }
    }
  }

  .device-list {
    width: 400px;
    height: 670px;
    overflow: visible;
    margin-top: 80px;

    .item {
      width: 100%;
      height: 100%;
      background: #0d0d0d;
      border: solid 2px transparent;
      border-radius: 30px;
      position: relative;
      cursor: pointer;
      transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);

      img {
        width: 100%;
        position: absolute;
        top: 30%;
        left: 50%;
        transform: translate(-50%, -50%);
        transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
      }

      .name {
        width: 100%;
        text-align: center;
        font-size: 30px;
        margin-top: 450px;
      }

      .next {
        @include flex-center;
        width: 50px;
        height: 50px;
        position: absolute;
        background-image: $linear-gradient;
        border-radius: 100%;
        position: absolute;
        left: 50%;
        bottom: 80px;
        margin-left: -25px;
        opacity: 0;
        transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);

        .iconfont {
          font-size: 25px;
          line-height: 50px;
          font-weight: bold;
        }
      }

      &.active,
      &:hover,
      &:active,
      &:focus {
        border: solid 2px $primary-color;
        box-shadow: inset 0 0 15px 10px #4136f1;

        img {
          width: 140%;
          max-width: none;
        }

        .next {
          opacity: 1;
        }
      }
    }
  }

  .text {
    width: 1200px;
    font-size: 56px;
    text-align: center;
    letter-spacing: 0;
    margin-top: -30px;
    color: transparent;
    background: linear-gradient(270deg, #8743ff 0%, #4136f1 50%, #8743ff 100%);
    background-clip: text;
    -webkit-text-fill-color: transparent;
    animation: scroll 1.5s linear infinite;
    display: inline;
  }

  .button {
    @include linear-button;
    width: 450px;
    height: 60px;
    line-height: 60px;
    margin-top: 80px;
  }

  .message {
    width: 1000px;
    min-height: 80px;
    font-size: 26px;
    text-align: center;
    color: #ffffff;
    margin-top: 40px;
  }
}

@keyframes scroll {
  0% {
    background-position: 0 0;
  }
  100% {
    background-position: 800px 0;
  }
}
</style>
<style lang="scss">
.dongle-list {
  .device-list {
    .swiper-slide-shadow-left,
    .swiper-slide-shadow-right {
      border-radius: 30px;
    }
  }
}
</style>
